var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInterlockingCircles = function SvgInterlockingCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.315,
    cy: 5.906,
    r: 5.315,
    stroke: "currentColor",
    fill: "transparent"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.685,
    cy: 5.906,
    r: 5.315,
    stroke: "currentColor",
    fill: "transparent"
  })));
};
export default SvgInterlockingCircles;